"use strict";

exports.__esModule = true;
exports.useMutation = useMutation;
exports.Mutation = Mutation;

var _invariant = _interopRequireDefault(require("invariant"));

var _react = require("react");

var _reactRelay = require("react-relay");

var _useMounted = _interopRequireDefault(require("@restart/hooks/useMounted"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function useMutation(mutation, userConfig,
/** if not provided, the context environment will be used. */
environment) {
  if (userConfig === void 0) {
    userConfig = {};
  }

  var _useState = (0, _react.useState)({
    loading: false,
    data: null,
    error: null
  }),
      state = _useState[0],
      setState = _useState[1];

  var isMounted = (0, _useMounted["default"])();
  var relayContext = (0, _react.useContext)(_reactRelay.ReactRelayContext);
  var resolvedEnvironment = environment || relayContext.environment;
  var _userConfig = userConfig,
      configs = _userConfig.configs,
      variables = _userConfig.variables,
      uploadables = _userConfig.uploadables,
      onCompleted = _userConfig.onCompleted,
      onError = _userConfig.onError,
      optimisticUpdater = _userConfig.optimisticUpdater,
      optimisticResponse = _userConfig.optimisticResponse,
      updater = _userConfig.updater;
  var mutate = (0, _react.useCallback)(function (config) {
    var mergedConfig = _extends({
      configs: configs,
      variables: variables,
      uploadables: uploadables,
      onCompleted: onCompleted,
      onError: onError,
      optimisticUpdater: optimisticUpdater,
      optimisticResponse: optimisticResponse,
      updater: updater
    }, config);

    !mergedConfig.variables ? process.env.NODE_ENV !== "production" ? (0, _invariant["default"])(false, 'you must specify variables') : invariant(false) : void 0;
    setState({
      loading: true,
      data: null,
      error: null
    });
    return new Promise(function (resolve, reject) {
      function handleError(error) {
        if (isMounted()) {
          setState({
            loading: false,
            data: null,
            error: error
          });
        }

        if (mergedConfig.onError) {
          mergedConfig.onError(error);
          resolve();
        } else {
          reject(error);
        }
      }

      (0, _reactRelay.commitMutation)(resolvedEnvironment, _extends({}, mergedConfig, {
        mutation: mutation,
        variables: mergedConfig.variables,
        onCompleted: function onCompleted(response, errors) {
          if (errors) {
            // FIXME: This isn't right. onError expects a single error.
            handleError(errors);
            return;
          }

          if (isMounted()) {
            setState({
              loading: false,
              data: response,
              error: null
            });
          }

          if (mergedConfig.onCompleted) {
            mergedConfig.onCompleted(response);
          }

          resolve(response);
        },
        onError: handleError
      }));
    });
  }, [resolvedEnvironment, configs, mutation, variables, uploadables, onCompleted, onError, optimisticUpdater, optimisticResponse, updater, isMounted]);
  return [mutate, state];
}

function Mutation(_ref) {
  var children = _ref.children,
      mutation = _ref.mutation,
      environment = _ref.environment,
      config = _objectWithoutPropertiesLoose(_ref, ["children", "mutation", "environment"]);

  var _useMutation = useMutation(mutation, config, environment),
      mutate = _useMutation[0],
      state = _useMutation[1];

  return children(mutate, state);
}